import { render, staticRenderFns } from "./CtrlModulosPage.vue?vue&type=template&id=144c88b0"
import script from "./CtrlModulosPage.vue?vue&type=script&lang=js"
export * from "./CtrlModulosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports